var container = { exports: {} };
export {
  container as __module
};
//# sourceMappingURL=container.js.map
